<template>
	<div class="page">
		<VDateInput
			label="Дата регистрации"
			v-model="registrationDate"
			:required="true"
			ref="phoneNumber"
			:validateMethod="validateRegistrationDate"
			@validate="onValidate($event, 'registrationDate')"
		/>
	</div>
</template>

<script>
import VDateInput from '@/lib/components/VDateInput/VDateInput.vue';

export default {
	name: "VComponentWithOtherControls",
	components: { VDateInput },
	data() {
		return {
			registrationDate: null,
			validationState: {},
		};
	},
	methods: {
		validateRegistrationDate(value) {
			if (!value) return "Дата регистрации не может быть пустой";
			return null;
		},
		autoFillDate() {
			this.registrationDate = new Date().toISOString().slice(0, 10);
		},
		clearDate() {
			this.registrationDate = null;
		},

		onValidate(validation, prop) {
			if (typeof this.validationState[prop] === "undefined") {
				this.validationState[prop] = validation;
			} else {
				const validationState = { ...this.validationState };
				validationState[prop] = validation;
				this.validationState = validationState;
			}
		},
	},
};
</script>

<style lang="scss" scoped></style>
